<template>
  <table class="table is-bordered w-100">
    <tbody>
      <tr v-for="(row, i) in months" :key="i">
        <td
          v-for="(month, j) in row"
          :key="j"
          class="is-pointer"
          :class="{'is-selected': isSelected(month)}"
          :data-month="month.month"
          @click="selectMonth(month)"
        >
          <div>{{month.text}}</div>
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
import { chunk } from "../utils/base";
import locale from "../locale/locale";

export default {
  name: "datepicker-list-month",
  props: {
    value: {
      type: Number,
    },
  },
  data() {
    return {
      selectedMonth: undefined,
    };
  },
  mounted() {
    if (this.value !== undefined) {
      this.selectedMonth = this.months
        .find((c) => c.find((m) => m.month === this.value))
        .find((m) => m.month === this.value);
    }
  },
  computed: {
    months() {
      const monthsLocale = locale.info.monthsShort;
      let months = monthsLocale.map((text, month) => {
        return { text, month: month + 1 };
      });
      return chunk(months, 3);
    },
  },
  methods: {
    isSelected(month) {
      return this.selectedMonth === month;
    },
    selectMonth(month) {
      this.selectedMonth = month;
      let newMonth = parseInt(month.month, 10);
      this.$emit("input", newMonth);
      this.$emit("change", newMonth);
    },
  },
};
</script>